import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import * as moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { ExcelServiceService } from '../../_models/excel-service.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reports-detail',
  templateUrl: './reports-detail.component.html',
  styleUrls: ['./reports-detail.component.css'],
  providers: [DatePipe]
})
export class ReportsDetailComponent implements OnInit {

  fileName: string = 'OrderDetails';
  toDayDateAndTime = new Date().toLocaleString();
  startDate: any;
  endDate: any;
  sourceType: any;
  export: any;
  type: any;
  orderList: any;
  orderListLength: boolean;
  startDateError: string;
  //PaymentStatusError : string;
  endDateError: string;
  orderStatusError: string;
  orderStatus: string;
  statusError: string;
  status: string;
  paymentStatus: string;
  paymentStatusError: string;
  invoiceType: string;
  invoiceTypeError: string;
  apiMethod = '';
  city: string
  cityError: string
  state: string
  stateError: string
  warehouseStatus: string
  warehouseStatusError: string
  statesList: any;
  channelList: any;
  constructor(private route: ActivatedRoute, private datePipe: DatePipe, private excelService: ExcelServiceService, private user: User, private alertService: AlertService, private api: ApiIntegration, private g: Globals) {
    setInterval(() => {
      this.toDayDateAndTime = this.datePipe.transform(new Date(), 'dd-MM-yyyy HH:mm:ss');
    }, 1000);
    this.g.page = "Reports";
    this.type = this.route.snapshot.queryParams.type;
    this.getAllConfiguredChannels();
  }

  getAllConfiguredChannels() {
    this.api.getAllConfiguredChannels(this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.channelList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
    this.stateList();
  }
  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  exportToXLSX() {
    if (this.type == 'Low Stock Report' || this.type == 'Out Of Stock Report' || this.type == 'Stock Status Report' || this.type == 'Inventory Adjustments') {
      let orderList = [];
      this.orderList.forEach((o) => {
        if (o.productsList.length) {
          o.productsList.forEach((s) => {
            orderList.push({ ...{ "warehouseId": o.warehouseId, "Warehouse Name": o.warehouseName }, ...s });
          });
        } else {
          orderList.push({ "warehouseId": o.warehouseId, "Warehouse Name": o.warehouseName });
        }
      });
      this.excelService.exportAsExcelFile(orderList, this.user.accountOwnerId);
    } else {
      this.excelService.exportAsExcelFile(this.orderList, this.user.accountOwnerId);
    }
  }


  exportToPdf(action = 'open') {
    const documentDefinition = this.getDocumentDefinition();
    switch (action) {
      case 'open': pdfMake.createPdf(documentDefinition).open();
        break;
      case 'print': pdfMake.createPdf(documentDefinition).print();
        break;
      case 'download':
        pdfMake.createPdf(documentDefinition).download();
        break;
      default: pdfMake.createPdf(documentDefinition).open();
        break;
    }
  }

  getDocumentDefinition() {
    return {
      pageSize: 'A4',
      pageMargins: [30, 25, 30, 15],
      header: {
        margin: [20, 10, 10, 10],
        columns: [
          { text: this.g.page, alignment: 'center', style: 'tableHeaders', bold: 'true' }
        ]
      },
      content: [
        {
          style: 'tableExample',
          table: {
            widths: [50, 50, 50, 50, 50, 30, 30, 40],
            body: this.getReportsData()
          }
        }
      ],
      styles: {
        content: {
          fontSize: 5
        },
        tableHeaders: {
          fontSize: 8,
          bold: true
        },
        headerText: {
          fontSize: 6,
          color: '#FFFFFF',
          fillColor: '#0074C1',
          bold: true
        }
      }

    };
  }

  getReportsData() {
    let reportsData = [];
    if (this.type == 'Order Detail') {
      reportsData.push([{ text: 'Order #', style: 'headerText' }, { text: 'Warehouse Name', style: 'headerText' }, { text: 'Customer Name', style: 'headerText' }, { text: 'Contact Name', style: 'headerText' }, { text: 'Created Date', style: 'headerText' }, { text: 'Order Type', style: 'headerText' }, { text: 'Channel Name', style: 'headerText' }, { text: 'Status', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.orderNumber, style: 'content' }, { text: od.warehouseName, style: 'content' }, { text: od.ownerName, style: 'content' }, { text: od.contactName, style: 'content' }, { text: od.createdDate, style: 'content' }, { text: od.orderType, style: 'content' }, { text: od.channelName, style: 'content' }, { text: od.orderStatus, style: 'content' }]);
      });
    } else if (this.type == 'Demand by SKU' || this.type == 'Product Sales' || this.type == 'Returned Products list') {
      reportsData.push([{ text: 'SKU', style: 'headerText' }, { text: 'Product Name', style: 'headerText' }, { text: 'Product Type', style: 'headerText' }, { text: 'Customer Name', style: 'headerText' }, { text: 'Channel Name', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.sku, style: 'content' }, { text: od.productName, style: 'content' }, { text: od.productType, style: 'content' }, { text: od.ownerName, style: 'content' }, { text: od.channelName, style: 'content' }]);
      });
    } else if (this.type == 'Low Stock Report' || this.type == 'Out Of Stock Report' || this.type == 'Stock Status Report' || this.type == 'Inventory Adjustments') {
      reportsData.push([{ text: 'SKU', style: 'headerText' }, { text: 'Warehouse Name', style: 'headerText' }, { text: 'Product Name', style: 'headerText' }, { text: 'Owner Name', style: 'headerText' }, { text: 'Stock Status', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        od.productsList.forEach((s) => {
          reportsData.push([{ text: s.sku, style: 'content' }, { text: od.warehouseName, style: 'content' }, { text: s.productName, style: 'content' }, { text: s.ownerName, style: 'content' }, { text: s.stockStatus, style: 'content' }]);
        });
      });
    } else if (this.type == 'Shipments' || this.type == 'Shipment Cost' || this.type == 'Shipped products') {
      reportsData.push([{ text: 'SKU', style: 'headerText' }, { text: 'Product Name', style: 'headerText' }, { text: 'Ordered Quantity', style: 'headerText' }, { text: 'Bin Location', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.sku, style: 'content' }, { text: od.productName, style: 'content' }, { text: od.quantity, style: 'content' }, { text: od.binLocation, style: 'content' }]);
      });
    } else if (this.type == 'Account Snapshot') {
      reportsData.push([{ text: 'Invoice Number', style: 'headerText' }, { text: 'Invoice Date', style: 'headerText' }, { text: 'Invoice Type', style: 'headerText' }, { text: 'Customer Name', style: 'headerText' }, { text: 'Total Amount', style: 'headerText' }, { text: 'Payment Status', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.invoiceNum, style: 'content' }, { text: od.invoiceDate, style: 'content' }, { text: od.invoiceType, style: 'content' }, { text: od.ownerName, style: 'content' }, { text: od.totalAmountInFormat, style: 'content' }, { text: od.paymentStatus, style: 'content' }]);
      });
    } else if (this.type == 'Customer details') {
      reportsData.push([{ text: 'Owner Name', style: 'headerText' }, { text: 'Contact Company Name', style: 'headerText' }, { text: 'Contact Name', style: 'headerText' }, { text: 'Contact Mobile', style: 'headerText' }, { text: 'Contact Email', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.ownerName, style: 'content' }, { text: od.companyName, style: 'content' }, { text: od.contactName, style: 'content' }, { text: od.mobile, style: 'content' }, { text: od.email, style: 'content' }]);
      });
    } else if (this.type == 'Order all details' || this.type == 'Products') {
      reportsData.push([{ text: 'SKU', style: 'headerText' }, { text: 'Product Name', style: 'headerText' }, { text: 'Product Type', style: 'headerText' }, { text: 'Customer Name', style: 'headerText' }, { text: 'Channel Name', style: 'headerText' }, { text: 'Status', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.sku, style: 'content' }, { text: od.productName, style: 'content' }, { text: od.productType, style: 'content' }, { text: od.ownerName, style: 'content' }, { text: od.channelName, style: 'content' }, { text: od.stockStatus, style: 'content' }]);
      });
    } else {
      return true;
    }
    return reportsData;
  }


  clearFields() {
    this.startDate = "";
    this.endDate = "";
    this.sourceType = "";
    this.orderList = "";
    this.status = "";
    this.statusError = "";
    this.orderListLength = false;
    this.startDateError = "";
    this.endDateError = "";
    this.orderStatus = null;
    this.paymentStatus = "";
    this.invoiceType = "";
    this.invoiceTypeError = "";
    this.paymentStatusError = "";
  }
  /*submitOrder(){
      this.startDateError = "";
      this.endDateError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }

      if (this.startDateError != "" || this.endDateError != "" ) {
        return false;
      }
    this.api.getOrderReports(this.user.accountOwnerId, this.endDate,"1",this.sourceType,this.startDate).subscribe((data:any)=> {this.orderList = data.getOHResponseList;},err=> {
           this.alertService.error('Error',err);
  })
  } */
  ngOnInit(): void {
  }

  validation() {
    if (this.type == 'Order Detail') {
      this.startDateError = "";
      this.endDateError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }

      if (this.startDateError != "" || this.endDateError != "") {
        return false;
      }
      return true;
    }
    else if (this.type == 'Demand by SKU') {
      this.startDateError = "";
      this.endDateError = "";
      this.orderStatusError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }
      if (this.orderStatus == '' || this.orderStatus === null || this.orderStatus === undefined || this.orderStatus === 'undefined') {
        this.orderStatusError = 'Please select orderStatus';
      }

      if (this.startDateError != "" || this.endDateError != "" || this.orderStatusError != "") {
        return false;
      }
      return true;
    }

    else if (this.type == 'Product Sales') {
      this.startDateError = "";
      this.endDateError = "";
      this.orderStatusError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }
      if (this.orderStatus == '' || this.orderStatus === null || this.orderStatus === undefined || this.orderStatus === 'undefined') {
        this.orderStatusError = 'Please select orderStatus';
      }
      if (this.startDateError != "" || this.endDateError != "" || this.orderStatusError != "") {
        return false;
      }
      return true;
    }

    else if (this.type == 'Returned Products list') {
      this.startDateError = "";
      this.endDateError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }

      if (this.startDateError != "" || this.endDateError != "") {
        return false;
      }
      return true;
    }
    else if (this.type == 'Account Snapshot') {
      this.startDateError = "";
      this.endDateError = "";
      //this.invoiceTypeError = "";
      //this.paymentStatusError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }
      /*  if (this.invoiceType == '' || this.invoiceType === null || this.invoiceType === undefined || this.invoiceType === 'undefined') {
         this.invoiceTypeError = 'Please select invoice type ';
       }
       if (this.paymentStatus == '' || this.paymentStatus === null || this.paymentStatus === undefined || this.paymentStatus === 'undefined') {
         this.paymentStatusError = 'Please select payment status';
       } */

      if (this.startDateError != "" || this.endDateError != "") {
        return false;
      }
      return true;
    }
    if (this.type == 'Products') {
      this.startDateError = "";
      this.endDateError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }

      if (this.startDateError != "" || this.endDateError != "") {
        return false;
      }
      return true;
    }

    if (this.type == 'Order all details') {
      this.startDateError = "";
      this.endDateError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }

      if (this.startDateError != "" || this.endDateError != "") {
        return false;
      }
      return true;
    }
    else if (this.type == 'Customer details') {
      this.startDateError = "";
      this.endDateError = "";
      this.statusError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }
      if (this.status == '' || this.status === null || this.status === undefined || this.status === 'undefined') {
        this.statusError = 'Please select Status';
      }
      if (this.startDateError != "" || this.endDateError != "" || this.statusError != "") {
        return false;
      }
      return true;
    }


    else {
      return true;
    }

  }

  submitOrder() {
    this.g.loaderDisplay = "display";
    if (!this.validation()) { this.g.loaderDisplay = ""; return; }
    let apiMethod = '';
    let query: any = {
      organizationId: "1",
      accountOwnerId: this.user.accountOwnerId,
    }
    if (this.type == 'Order Detail') {
      apiMethod = 'getOrderReports';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      //query.toDate =this.endDate;
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
      query.sourceType = this.sourceType || '';
    }
    else if (this.type == 'Demand by SKU') {
      apiMethod = 'getDemandBySKUReports';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
      query.storeType = this.sourceType || '';
      query.status = this.orderStatus || '';
    }
    else if (this.type == 'Product Sales') {
      apiMethod = 'geSalesProductsReport';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
      query.storeType = this.sourceType || '';
      query.status = this.orderStatus || '';
    }

    else if (this.type == 'Low Stock Report') {
      apiMethod = 'getInventoryReports';
      query.stockStatus = "LOW_STOCK";
    }
    else if (this.type == 'Out Of Stock Report') {
      apiMethod = 'getInventoryReports';
      query.stockStatus = "OUT_OF_STOCK";
    }
    else if (this.type == 'Stock Status Report') {
      apiMethod = 'getInventoryReports';
      query.stockStatus = "IN_STOCK";
    }
    else if (this.type == 'Inventory Adjustments') {
      apiMethod = 'getInventoryAdjustReports';
    }
    else if (this.type == 'Returned Products list') {
      apiMethod = 'getReturnProductsReport';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
    }
    else if (this.type == 'Account Snapshot') {
      apiMethod = 'getInvoiceReportsByPaymentStatus';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
      //query.invoiceType =this.invoiceType;
      query.paymentStatus = this.paymentStatus || "ALL";
    }
    else if (this.type == 'Products') {
      apiMethod = 'getProductsReportByField';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
    }
    else if (this.type == 'Order all details') {
      apiMethod = 'getAllOrderReportsByFields';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
    }
    else if (this.type == 'Customer details') {
      apiMethod = 'getAllContactsReports';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
      query.status = this.status;
    }
    this.api.getReports(apiMethod, query).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orderListLength = false;
      if (this.type == 'Account Snapshot') {
        this.orderList = data.getProductResponses || data.getOHResponseList || data.getProductsReportsResponses || data.invoicesResponseList || data.getAllContactsReportResponseList || data.getAccountOwnersResponses;
      } else {
        this.orderList = data.getProductResponses || data.getOHResponseList || data.getProductsReportsResponses || data.invoicesResponseList || data.getAllContactsReportResponseList || data.getAccountOwnersResponses;
      }

      if (!this.orderList.length) {
        this.orderListLength = true;
      }
      //this.alertService.success();
      //console.log(data);
    }, (err) => { this.alertService.error('Error', err); this.g.loaderDisplay = ""; });
  }

  exportToXLSX1(): void {

    let element = document.getElementById('export');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, this.fileName + "_" + this.user.accountOwnerId + '_' + this.toDayDateAndTime);

  }
}
